import { ToDoStatus } from "./enum/ToDoStatus.enum";

/**
 * One place for "what colour is this status". Both detail drawers, the subtask
 * rows and the status dropdown read from here so a status never looks like two
 * different things on the same screen.
 *
 * Text colours are the readable pairings from the brand guide: `warning` and
 * `success` are fills, not inks, so their badges write in `warning-ink` / `ink`.
 */
export const statusDotClass: Record<ToDoStatus, string> = {
	[ToDoStatus.TO_DO]: "bg-grey-soft",
	[ToDoStatus.IN_PROGRESS]: "bg-accent",
	[ToDoStatus.QA]: "bg-warning",
	[ToDoStatus.DONE]: "bg-success",
};

export const statusBadgeClass: Record<ToDoStatus, string> = {
	[ToDoStatus.TO_DO]: "bg-surface text-subtle",
	[ToDoStatus.IN_PROGRESS]: "bg-accent-tint text-accent-strong",
	[ToDoStatus.QA]: "bg-warning-light text-warning-ink",
	[ToDoStatus.DONE]: "bg-success-light text-ink",
};

/**
 * Mirrors the board's drag rule (ToDoContainer `isBlocked`): Done is only
 * reachable from QA. The dropdown greys the option out rather than letting the
 * socket reject it after the fact.
 */
export const canMoveTo = (current: ToDoStatus | undefined, next: ToDoStatus) =>
	next !== ToDoStatus.DONE || current === ToDoStatus.QA;
